import { ControlSheetNote } from '../types/types'
import styles from './ControlSheetNoteView.module.scss'

interface Props {
    note: ControlSheetNote
}

export const ControlSheetNoteView = ({ note }: Props) => {
    return (
        <div className={styles.noteContainer}>
            <div className={styles.noteText}>{note.note}</div>
            <div className={styles.noteInfoContainer}>
                <span className={styles.noteAuthor}>{note.author}</span>
                <span className={styles.noteTime}>
                    {note.createdAt.toLocaleTimeString('en-GB', {
                        timeZone: 'Europe/London',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false, // Use 24-hour format
                    })}
                </span>
            </div>
        </div>
    )
}
